import React from "react";
import { createRoot } from "react-dom/client";

import "@/styles/fonts.css";
import "@/styles/tokens.css";
import "@/styles/base.css";
import "@/styles/components.css";
import "@/styles/layout.css";
import "@/styles/screens.css";
import { PlatformApp } from "./App";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PlatformApp />
  </React.StrictMode>,
);
